/**
 * LA MARQUE — un seul composant, après en avoir compté quatre.
 *
 * Le dépôt portait `ZenkartBrand`, `Logo`, `ZenkartLogo` et `VeltrixLogo` —
 * ce dernier au nom de la marque d'avant. Les deux derniers n'étaient importés
 * nulle part et sont partis le 2026-09-10 ; `Logo` a été absorbé ici, parce
 * qu'un logo qui existe en deux composants finit par exister en deux tailles,
 * deux graisses et deux couleurs.
 *
 * Deux formes, une seule source :
 *   complète     la marque + le mot ZENKART (par défaut)
 *   marqueSeule  la loupe seule, quand le nom est déjà écrit à côté
 *
 * Le mot est en Archivo : c'est la police des titres et des chiffres, et un
 * mot-symbole est un titre. Il monte à 700 et pas au-delà — au-dessus, la
 * graisse est fabriquée par le navigateur (cf. styles/typographie.test.js).
 */
import React from 'react';
import iconSrc from '../../assets/zenkart-icon.png';
import mark1x from '../../assets/logo-zenkart-mark.png';
import mark2x from '../../assets/logo-zenkart-mark@2x.png';
import { BLUE, FONT_DISPLAY, ORANGE, SPACE, TYPE } from '../../styles/tokens';

const TAILLES = {
  lg: { icone: 52, texte: TYPE.t1,      gap: SPACE[3] },
  md: { icone: 30, texte: TYPE.t3,      gap: SPACE[2] },
  sm: { icone: 22, texte: TYPE.corps,   gap: SPACE[1] + 1 },
};

export default function ZenkartBrand({
  size = 'md', marqueSeule = false, className = '', style,
}) {
  const t = TAILLES[size] || TAILLES.md;

  if (marqueSeule) {
    return (
      <img
        src={mark1x}
        srcSet={`${mark1x} 1x, ${mark2x} 2x`}
        alt="ZENKART"
        className={`zk-logo ${className}`.trim()}
        style={style}
        draggable="false"
      />
    );
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: t.gap, ...style }}>
      <img
        src={iconSrc}
        alt=""
        aria-hidden="true"
        style={{ height: t.icone, width: t.icone, display: 'block', flexShrink: 0 }}
      />
      <span style={{
        fontFamily: FONT_DISPLAY,
        fontSize: t.texte,
        fontWeight: 700,
        letterSpacing: '0.01em',
        lineHeight: 1,
        userSelect: 'none',
      }}>
        <span style={{ color: BLUE }}>ZEN</span><span style={{ color: ORANGE }}>KART</span>
      </span>
    </span>
  );
}
